<article class="block-featured" [class.section-inset-y]="!block.image?.url" [class.section-inset-t]="block.image?.url">
  <div class="container">
    <div class="row">
      <div class="col-md-7">
        <h1
          [innerHTML]="block.title | highlight : ' font-display text-primary-gradient'"
          data-split
          class="text-light splitting splitting--word-in mb-0"
        ></h1>
        <fstr-image
          [width]="706"
          [height]="541"
          [imageSizes]="[400, 700, 1200, 1400]"
          *ngIf="block.image?.url"
          [image]="block.image!"
          [alt]="block.image?.alt || block.title || 'block-image'"
          [imageSizes]="[400, 800, 1200, 1400]"
          class="block-featured__image d-none d-md-block"
        ></fstr-image>
      </div>
      <div class="col-md-5 d-flex flex-column flex-gap-3">
        <div
          class="markdown-content d-flex flex-column flex-gap-3 anim-fade-up delay--1"
          fstrDynamicContent
          [innerHTML]="block.text || '' | resizeHtmlImages | stripEmbed : cookiePreferences | safe"
          [class.anim--active]="inviewPort"
        ></div>

        <div class="d-flex flex-gap-3">
          <fstr-link cssClasses="button button button--primary-gradient has--dot" [button]="block.button!">
            <ng-container *ngIf="!block.button?.text">{{ 'lees-meer' | fromDictionary }}</ng-container>
          </fstr-link>
          <fstr-link cssClasses="button button-outline text-light button--primary has--dot" [button]="block.secondaryButton!">
            <ng-container *ngIf="!block.secondaryButton?.text">{{ 'lees-meer' | fromDictionary }}</ng-container>
          </fstr-link>
        </div>
        <fstr-image
          [width]="706"
          [height]="541"
          [imageSizes]="[300, 450, 800, 1400]"
          *ngIf="block.image"
          [image]="block.image"
          [alt]="block.image?.alt || block.title || 'block-image'"
          class="block-featured__image d-block d-md-none"
        ></fstr-image>
      </div>
    </div>
  </div>
</article>
